<ng-template #template>
    <div class="modal-header">
        <h4 class="modal-title">{{ (!cotacao?.is_from_api ? 'support.cotacoes.modal.editar-cotacao.titulo' : 'support.cotacoes.modal.editar-cotacao.titulo-distribuir') | translate }}{{cotacao?.quotation_id}}</h4>
        <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="fecharModal(false);"></button>
    </div>
    <form name="cotacaoForm" class="form-cotacao form-validate" [formGroup]="cotacaoForm" (ngSubmit)="salvar(0)">
        <div class="modal-body">
            <div class="row">
                <div class="col-sm-3 col-md-3 marca">
                    <div class="mb-3 form-group">
                        <label>{{ 'support.cotacoes.modal.editar-cotacao.dados.marca.label' | translate}}</label>
                        <select name="marca" required class="form-select" formControlName="marca" [disabled]="loading_marca ? 'disabled' : null">
                            <option value="-1">{{'support.cotacoes.modal.editar-cotacao.dados.marca.placeholder' | translate}}</option>
                            <optgroup label="---------">
                                @for (marca of listas?.marcas | filterBy: { is_principal: 1 }; track marca) {
                                    <option [value]="marca?.id">{{marca.name}}</option>
                                }
                            </optgroup>
                            <optgroup label="---------">
                                @for (marca of listas?.marcas; track marca) {
                                    <option [value]="marca?.id">{{marca.name}}</option>
                                }
                            </optgroup>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4 col-md-3">
                    <div class="mb-3 form-group">
                        <label>{{ 'support.cotacoes.modal.editar-cotacao.dados.chassi.label' | translate}}</label>
                        <input name="chassi" formControlName="chassi" mask="AAAAAAAAAAAAAAAAA" restrict="reject" maxlength="17" type="text" class="form-control text-uppercase">
                    </div>
                </div>
                <div class="col-sm-3 col-md-3">
                    <div class="mb-3 form-group">
                        <label>{{ 'support.cotacoes.modal.editar-cotacao.dados.ano.label' | translate}}</label>
                        <input name="ano" formControlName="ano" mask="0000" min="1950" max="CurrentDate.getFullYear() + 1" required type="text" class="form-control">
                    </div>
                </div>
                <div class="col-sm-3 col-md-3">
                    <div class="mb-3 form-group">
                        <label>{{ 'support.cotacoes.modal.editar-cotacao.dados.placa.label' | translate}}</label>
                        <input name="placa" formControlName="placa" mask="SSS-0A00" restrict="reject" required type="text" class="form-control text-uppercase">
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col-sm-12 col-md-12">
                    <div class="mb-3 form-group">
                        <label>{{ 'support.cotacoes.modal.editar-cotacao.dados.veiculo.label' | translate}}</label>
                        <input id="veiculo" name="veiculo" formControlName="veiculo" required maxlength="200" type="text" class="form-control text-capitalize restrict-special-characters" placeholder="{{ 'support.cotacoes.modal.editar-cotacao.dados.veiculo.placeholder' | translate}}" [ngClass]="{'is-invalid': displayMessage.veiculo }">
                        @if (displayMessage.veiculo) {
                            <span class="text-danger">
                                <p [innerHTML]="displayMessage.veiculo"></p>
                            </span>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            @if (!cotacao?.is_from_api && !hasAnySellerParticipating) {
                <button id="distribuir" type="button" class="btn btn-outline-warning" (click)="distribuir(0);">{{ 'support.cotacoes.modal.editar-cotacao.botoes.distribuir' | translate}}</button>
            }
            <button id="salvar" type="submit" class="btn btn-primary" [disabled]="!cotacaoForm.valid || !cotacaoForm.dirty ? 'disabled' : null">{{ (!cotacao?.is_from_api ? 'support.cotacoes.modal.editar-cotacao.botoes.salvar' : 'support.cotacoes.modal.editar-cotacao.botoes.salvar-distribuir') | translate}}</button>
            <button id="closeModal" type="button" class="btn btn-light" (click)="fecharModal(false);">{{ 'support.cotacoes.modal.editar-cotacao.botoes.fechar' | translate}}</button>
        </div>
    </form>
    <ngx-loading [show]="loading" [template]="templateEdicao"></ngx-loading>
</ng-template>
<ng-template #templateEdicao></ng-template>
